import styled, { css } from 'styled-components';
import { colors, layout, remCalc, media } from '@prisjakt/ui-base';
import { applyFilterAreaHeight } from './components/apply-filter-button/styles';

export const FilterWrapper = styled.div`
  /* Makes sure no content is hidden behind the "apply filter" area */
  padding-bottom: ${applyFilterAreaHeight}px;
  ${media.largeUp`
    padding-bottom: 0;
  `}
`;

export const Filter = styled.div`
  border-top: 1px solid ${p => p.theme.lines.secondary};
  border-left: 1px solid ${p => p.theme.lines.secondary};
  border-right: 1px solid ${p => p.theme.lines.secondary};
  margin-bottom: ${layout.margins.component.desktop.rem};

  ${props =>
    props.horizontal &&
    css`
      background: ${colors.semiWhite};
      border-left: none;
      border-right: none;
    `}

  ${media.mediumDown`
    border-left: none;
    border-right: none;
    margin-bottom: ${layout.margins.component.mobile.rem};
  `};
`;

export const HeaderWrapper = styled.div`
  position: relative;

  ${props =>
    props.mobileOpen &&
    css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin: 10px;
    `}
`;

export const Header = styled.div`
  .pj-ui-panel-header--header {
    justify-content: normal;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${p => p.theme.lines.secondary};
  background-color: ${colors.semiWhite};
`;

export const ExpansionButton = styled.button`
  cursor: pointer;
  text-transform: uppercase;
  font-size: ${remCalc(14)};
  font-weight: bold;
  text-align: left;
  color: ${p => p.theme.text.callToAction};
  margin-left: 10px;
  height: 35px;
  flex: 1;
  justify-content: center;
`;

export const ArrowButton = styled.button`
  cursor: pointer;
  margin-right: 10px;
  height: 35px;
`;

export const CloseButton = styled.button.attrs({
  'data-test': 'FiltersCloseButton',
})`
  display: none;
  margin-bottom: 0.5rem;
  cursor: pointer;

  ${props =>
    props.mobileOpen &&
    css`
      ${media.mediumDown`
        display: block;
        position: fixed;
        top: 5px;
        right: 5px;
        padding: 10px 12px;
        background: ${p => p.theme.bg.primary};
        border-radius: 50%;
        z-index: 100;
        box-shadow: 0 2px 10px -4px rgba(0,0,0,.5);
      `};
    `}
`;

export const Input = styled.input`
  width: 100%;
  font-style: italic;
  margin-bottom: 10px;
  border: 1px solid ${p => p.theme.lines.secondary};
  padding: 5px;
  outline: 0;

  ${media.mediumDown`
    margin-top: 5px;
  `};

  &:focus {
    border-color: ${colors.lightBlue2};
    box-shadow: inset 0 0 0 1px ${colors.lightBlue2};
  }
`;

export const MoreFilters = styled.div`
  background: ${colors.white};
`;
